import React from "react";
import PropTypes from "prop-types";
import styled from "styled-components";
import { Typography } from "@material-ui/core";
import { useTranslation } from "react-i18next";

const Footer = styled(Typography)`
  && {
    margin-top: 16px;
    color: rgba(0, 0, 0, 0.6);
    line-height: 1.5;
  }

  a {
    color: inherit;
    font-weight: 500;
  }
`;

function telephoneHref(phone) {
  const digits = String(phone || "").replace(/\D/g, "");
  if (!digits) return null;
  return digits.length >= 10 && !digits.startsWith("55")
    ? `tel:+55${digits}`
    : `tel:+${digits}`;
}

function SupportContact({ phone, email }) {
  const { t } = useTranslation();
  if (!phone && !email) return null;

  const phoneLink = phone ? (
    <a href={telephoneHref(phone) || undefined}>{phone}</a>
  ) : null;
  const emailLink = email ? <a href={`mailto:${email}`}>{email}</a> : null;

  return (
    <Footer variant="body2">
      {t("login.forgotSupportLead")}
      {phoneLink ? (
        <> 
          {' '}
          {phoneLink}
        </>
) : null}
      {phone && email ? ` ${t("login.forgotSupportJoin")} ` : null}
      {!phone && email ? " " : null}
      {emailLink}
      .
    </Footer>
  );
}

SupportContact.propTypes = {
  phone: PropTypes.string,
  email: PropTypes.string
};

SupportContact.defaultProps = {
  phone: "",
  email: ""
};

export default SupportContact;
